var map = {
	"./en/jacket.png": "4d45",
	"./en/jumpsuits.png": "870b",
	"./en/onePieceGarment.png": "7395",
	"./en/onePieceSkirt.png": "f5be",
	"./en/shortSkirt.png": "d50d",
	"./en/trousers.png": "ce13",
	"./ger/jacket.png": "5d32",
	"./ger/jumpsuits.png": "145e",
	"./ger/onePieceGarment.png": "bff2",
	"./ger/onePieceSkirt.png": "e824",
	"./ger/shortSkirt.png": "a906",
	"./ger/trousers.png": "108b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bdf1";